import { loadCategories, loadWorks } from "./api";
import { pieceCard } from "./render";
import type { Category, Work } from "./types";

export async function initGallery(): Promise<void> {
  const [works, cats] = await Promise.all([loadWorks(), loadCategories()]);
  const filters = document.getElementById("filtros");
  const gallery = document.getElementById("galeria");
  if (!filters || !gallery) return;

  const params = new URLSearchParams(location.search);
  let current = params.get("cat") ?? "";

  const draw = (): void => {
    const list = current ? works.filter((w) => w.category === current) : works;
    const sorted = [...list].sort((a, b) => b.createdAt.localeCompare(a.createdAt));
    gallery.innerHTML = sorted.length
      ? sorted.map((work) => pieceCard(work, cats)).join("")
      : `<p class="empty">No hay piezas en esta categoría todavía.</p>`;
    filters.innerHTML = renderFilters(cats, current);
  };

  filters.addEventListener("click", (event) => {
    const button = (event.target as HTMLElement).closest<HTMLButtonElement>("button[data-cat]");
    if (!button) return;
    current = button.dataset.cat ?? "";
    const url = new URL(location.href);
    if (current) url.searchParams.set("cat", current);
    else url.searchParams.delete("cat");
    history.replaceState({}, "", url);
    draw();
  });

  draw();
}

function renderFilters(cats: Category[], current: string): string {
  const all: Array<{ id: string; name: string }> = [{ id: "", name: "Todas" }, ...cats];
  return all
    .map(
      (cat) =>
        `<button class="filter" type="button" data-cat="${cat.id}" aria-pressed="${cat.id === current}">${cat.name}</button>`
    )
    .join("");
}

export function workById(works: Work[], id: string): Work | undefined {
  return works.find((w) => w.id === id || w.slug === id);
}
